
import React, {useEffect, useState} from 'react';
import {session_count} from '../../../service/basket'
import rombus from '../../../media/rombus.gif'

const SessionCountBlock = ({client_id, agent_id, prod_type=null, date_from=null, date_to=null, title=null, sub_title=null, token, timeout=1000}) => {

    const [count_v, set_d_count] = useState(null);

    const  popd = (client_id, agent_id, date_from, date_to, prod_type) => {
        const limit = 8;
        setTimeout(() => {
          session_count(client_id, agent_id, date_from, date_to, prod_type, token).then((d) => {
            if(d != null){
                set_d_count(d)
            }
        });          
        }, timeout);

    }
    

    let cTitle = 'Abandoned Baskets';
    if(title != null){
        cTitle = title;
    }

    let cSubTitle = '';
    if(sub_title != null){
        cSubTitle = sub_title;
    }


    useEffect(() =>{
        set_d_count(null);
        popd(client_id, agent_id,date_from, date_to, prod_type);
    }, [client_id, agent_id, date_from, date_to, prod_type])


    if(count_v == null){
      return <>
            <div className='countBlock'>
                <div className='countBlockTitle'>
                    {cTitle}
                </div>
                <div className='countBlockContent'>
                    <div style={{justifyContent: 'center'}}>
                            <img src={rombus}></img>
                    </div>
                </div>
            </div>
        </>
    }
    const formatted = Number(count_v).toLocaleString('en-US');

    return (<div className='countBlock'>
        <div className='countBlockTitle'>
            {cTitle}
        </div>
        <div className='countBlockContent'>
            <div className='info'>{formatted}</div>
            <div className='info infosmall'>{cSubTitle}</div>
        </div>
    </div>)

}

export default SessionCountBlock
